module.exports = __webpack_public_path__ + "static/media/Azumarill_gaussian2.1a60ae4f.png";